import type { Environment } from "@porsche-customer/slfinrtl-environment"

export function mapLegacyEnvironment(environment: Environment | null) {
	switch (environment) {
		case "dev":
		case "local":
			return "K"
		case "preview":
			return "PP"
		case "prod":
			return "P"
		case null:
			return null
	}
}
